// extracted by css-extract-rspack-plugin
export default {"messagePopover":"messagePopoverWithTail-module__messagePopover___romsK","messagePopoverContent":"messagePopoverWithTail-module__messagePopoverContent___hMx4W"};